export default __webpack_public_path__ + "static/media/Welcome.ecaad76f.png";